<template>
  <div :class="[{ 'albumCard': true, 'active': this.loaded }]">
    <div :class="[{ 'albumImage animate__animated animate__faster': true, 'animate__fadeInRight': this.klass == 'fadeIn', 'animate__fadeOutLeft': this.klass == 'fadeOut' }]"><img :src="image" :alt="title" :title="title" /></div>
    <div class="trackDetails">
      <small :class="[{ 'animate__animated animate__faster': true, 'animate__fadeInRight': this.klass == 'fadeIn', 'animate__fadeOutLeft': this.klass == 'fadeOut'  }]">Now Playing</small>
      <h1 :class="[{ 'albumImage animate__animated animate__fast': true, 'animate__fadeInRight': this.klass == 'fadeIn', 'animate__fadeOutLeft': this.klass == 'fadeOut' }]">{{ title }}</h1>
      <h2 :class="[{ 'albumImage animate__animated': true, 'animate__fadeInRight': this.klass == 'fadeIn', 'animate__fadeOutLeft': this.klass == 'fadeOut' }]">{{ artist }}</h2>
    </div>
    
  </div>
  <div class="vibes">
      <div>
        <svg class="brandIcon" width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M136.063 171.972C136.368 171.261 136.93 170.87 137.635 170.87C137.756 170.87 137.848 170.905 137.905 170.927C138.915 171.119 139.434 172.086 139.434 172.954C139.434 173.822 138.958 175.038 137.635 175.038C136.312 175.038 135.835 173.793 135.835 172.954C135.835 172.577 135.956 172.214 136.063 171.972ZM123.443 158.833C123.244 158.947 123.052 159.061 122.867 159.175C122.582 159.346 122.291 159.523 121.985 159.68C115.789 162.902 109.45 164.517 103.169 164.517C98.0615 164.517 92.9966 163.45 88.0882 161.302C78.1291 156.955 69.4434 148.391 63.6244 137.187C57.8054 125.983 55.7923 113.946 57.9619 103.304C60.2383 92.1074 67.0247 83.0873 77.5742 77.2115L77.8232 77.0692C77.937 76.998 78.0509 76.934 78.1718 76.8629C78.2572 76.8131 78.3425 76.7633 78.435 76.7064C78.5417 76.6424 78.6484 76.5712 78.7622 76.5143L79.0823 76.3436L124.944 157.951L123.443 158.826V158.833ZM148.177 132.235L143.717 130.919C141.54 139.94 137.798 146.932 132.292 152.31C132.186 152.417 132.079 152.516 131.965 152.616L131.773 152.794C131.602 152.957 131.424 153.114 131.254 153.27L130.905 153.583L77.745 59.093C70.361 44.0263 72.5805 32.9788 84.1615 27.1243C89.9093 24.2148 99.2993 23.2403 104.45 26.7544C105.275 27.5511 105.118 27.8072 101.96 31.2787L104.862 31.4707C108.085 31.677 112.04 31.926 115.903 32.2959C111.257 26.8896 106.505 23.1976 98.9721 22.5929C93.6582 22.1661 88.3087 23.162 83.5426 25.5024C68.3977 32.929 63.4679 46.6726 70.6669 61.3765L78.1789 74.743L77.8374 74.9209C77.7379 74.9707 77.6454 75.0276 77.5458 75.0916C77.4462 75.1485 77.3537 75.2054 77.247 75.2623C77.1403 75.3192 77.0336 75.3832 76.934 75.4402C76.8415 75.4971 76.7562 75.5469 76.6637 75.6038C65.7514 81.6859 57.7201 91.5312 54.0352 103.333C50.1867 115.668 51.3747 128.842 57.3928 140.416C65.8296 156.649 82.4115 166.737 100.672 166.737H100.679C108.341 166.737 116.002 164.866 122.824 161.323C123.13 161.167 123.415 160.996 123.699 160.832C123.912 160.704 124.126 160.583 124.354 160.462L125.862 159.602L132.805 172.036C132.819 172.243 133.167 177.179 137.343 177.521C138.773 177.521 139.982 177.066 140.815 176.212C141.59 175.408 141.974 174.291 141.931 172.975C141.839 170.286 139.2 168.259 139.178 168.238L139.079 168.124L132.001 155.54L132.25 155.341C132.342 155.269 132.428 155.191 132.52 155.113C132.605 155.035 132.691 154.964 132.783 154.892L133.31 154.451C140.224 148.746 144.955 141.689 148.184 132.235" />
          <path d="M200 200H0V0H200V200ZM2.51823 197.482H197.482V2.51823H2.51823V197.482Z"/>
        </svg>
      </div>
      <div>
        <p>+ Vibes Only.</p>
      </div>
    </div>
</template>

<script>
export default {
  name: "SoundTrack",
  data() {
    return {};
  },
  props: {
    title:{
      type: String,
      required: true,
      default: ''
    },
    album:{
      type: String,
      required: true,
      default: ''
    },
    artist:{
      type: String,
      required: true,
      default: ''
    },
    image:{
      type: String,
      required: true,
      default: ''
    },
    color1:{
      type: String,
      required: true,
      default: ''
    },
    color2:{
      type: String,
      required: true,
      default: ''
    },
    klass:{
      type: String,
      required: true,
      default: ''
    },
    duration:{
      type: Number,
      required: true,
      default: ''
    },
    remaining:{
      type: Number,
      required: true,
      default: ''
    },
    loaded:{
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    getRemainingMins: function(){
      const time = ((this.remaining / 60)).toFixed(2).toString().split('.');
      const mins = time[0];
      const secs = time[1];

      return `${ mins } min  ${ secs } sec`;
    }
  },
};
</script>

<style lang="scss" scoped></style>